// Georgia Tech's undergraduate majors (#2596, founder 2026-09-30: "majors
// offered by the college in the public page"). Read on 2026-09-30 from
// Georgia Tech's Undergraduate Majors and Minors page (gatech.edu/academics/
// bachelors-degree-programs, the page the admission site's Major Selection
// page links for "the majors we offer"), which lists every bachelor's degree
// under its college. Cross-checked against the official Catalog's Programs
// page (catalog.gatech.edu/programs/, All tab): the same 42 BS programs. The
// catalog's own Bachelor's tab and its college Programs tabs each miss some
// majors, so the college grouping comes from the gatech.edu page. Mathematics
// and Computing appears under both Computing and Sciences, as the page lists
// it. Minors, the Computer Engineering dual BS and the Chemical and
// Biomolecular Engineering biotechnology option are left out. Each college's
// rate is the Fact Book's fall 2025 first-year admission by college (the
// college file's `factBook` source, same numbers as its byMajor table). The
// Music Technology flag and the College of Design note quote the Major
// Selection page (the college file's `majors` source). The KB's majors list
// was the starting point; the official pages win.
const majors = {
    "slug": "georgia-institute-of-technology",
    "read": "2026-09-30",
    "intro": "Every undergraduate major at Georgia Tech, grouped by the college that offers it, from Georgia Tech's official majors list and Catalog. All lead to a Bachelor of Science. Minors, dual-degree tracks and degree options are left out.",
    "groups": [
        {
            "name": "College of Computing",
            "source": {
                "label": "Georgia Tech, Undergraduate Majors and Minors",
                "url": "https://www.gatech.edu/academics/bachelors-degree-programs"
            },
            "majors": [
                {
                    "name": "Computational Media",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Computing",
                    "degree": "BS"
                }
            ],
            "rate": {
                "text": "Fall 2025, first-year applicants whose intended major is in this college: 13,556 applied, 1,310 accepted (9.7%).",
                "source": "factBook"
            }
        },
        {
            "name": "College of Design",
            "source": {
                "label": "Georgia Tech, Undergraduate Majors and Minors",
                "url": "https://www.gatech.edu/academics/bachelors-degree-programs"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Arts, Entertainment, and Creative Technologies",
                    "degree": "BS"
                },
                {
                    "name": "Construction Science and Management",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BS"
                },
                {
                    "name": "Music Technology",
                    "degree": "BS",
                    "flag": "A portfolio and an essay are required with the application.",
                    "flagSource": "majors"
                },
                {
                    "name": "Urban Planning and Spatial Analytics",
                    "degree": "BS"
                }
            ],
            "rate": {
                "text": "Fall 2025, first-year applicants whose intended major is in this college: 2,007 applied, 313 accepted (15.6%).",
                "source": "factBook"
            },
            "note": "A portfolio is recommended for some College of Design majors, and design faculty review it.",
            "noteSource": "majors"
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Georgia Tech, Undergraduate Majors and Minors",
                "url": "https://www.gatech.edu/academics/bachelors-degree-programs"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical and Biomolecular Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear and Radiological Engineering",
                    "degree": "BS"
                }
            ],
            "rate": {
                "text": "Fall 2025, first-year applicants whose intended major is in this college: 32,934 applied, 3,795 accepted (11.5%).",
                "source": "factBook"
            }
        },
        {
            "name": "College of Sciences",
            "source": {
                "label": "Georgia Tech, Undergraduate Majors and Minors",
                "url": "https://www.gatech.edu/academics/bachelors-degree-programs"
            },
            "majors": [
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric and Oceanic Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Computing",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Solid Earth and Planetary Sciences",
                    "degree": "BS"
                }
            ],
            "rate": {
                "text": "Fall 2025, first-year applicants whose intended major is in this college: 10,419 applied, 1,541 accepted (14.8%).",
                "source": "factBook"
            }
        },
        {
            "name": "Ivan Allen College of Liberal Arts",
            "source": {
                "label": "Georgia Tech, Undergraduate Majors and Minors",
                "url": "https://www.gatech.edu/academics/bachelors-degree-programs"
            },
            "majors": [
                {
                    "name": "Applied Languages and Intercultural Studies",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Economics and International Affairs",
                    "degree": "BS"
                },
                {
                    "name": "Global Economics and Modern Languages",
                    "degree": "BS"
                },
                {
                    "name": "History, Technology, and Society",
                    "degree": "BS"
                },
                {
                    "name": "International Affairs",
                    "degree": "BS"
                },
                {
                    "name": "International Affairs and Modern Languages",
                    "degree": "BS"
                },
                {
                    "name": "Literature, Media, and Communication",
                    "degree": "BS"
                },
                {
                    "name": "Public Policy",
                    "degree": "BS"
                }
            ],
            "rate": {
                "text": "Fall 2025, first-year applicants whose intended major is in this college: 3,200 applied, 558 accepted (17.4%).",
                "source": "factBook"
            }
        },
        {
            "name": "Scheller College of Business",
            "source": {
                "label": "Georgia Tech, Undergraduate Majors and Minors",
                "url": "https://www.gatech.edu/academics/bachelors-degree-programs"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "BS"
                }
            ],
            "rate": {
                "text": "Fall 2025, first-year applicants whose intended major is in this college: 3,852 applied, 511 accepted (13.3%).",
                "source": "factBook"
            }
        }
    ]
};

export default majors;
